import { createFileRoute } from "@tanstack/react-router";
import { SettingsPage } from "@/components/settings/settings-page.js";

export const Route = createFileRoute("/_authenticated/configuration/settings")({
  component: SettingsPage,
});
